export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_07.a557a664.png";